import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

export default function AvailabilityCart() {
  return (
    <Wrapper>
      <h4>Cabaña en Chaica, Carretera Austral.</h4>
      <hr className="hr" />
      <h5>EL PERFECTO ESCAPE PARA TU FIN DE SEMANA</h5>
      <p>
        ¡Porque fue construida para disfrutar! ¡No dudes en consultar
        disponibilidad!
      </p>

      <Link to="/reserva" className="btn">
        Reserva
      </Link>
    </Wrapper>
  )
}

const Wrapper = styled.article`
  min-width: 245px;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%);
  background-color: var(--white);
  padding: 30px 10px;
  text-align: center;
  h5 {
    margin-top: 1rem;
    font-weight: bold;
  }
  .content {
    max-width: 700px;
    color: red;
  }
  @media screen and (min-width: 400px) {
    min-width: 300px;
  }

  @media screen and (min-width: 768px) {
    padding: 40px 30px;
  }
`
